import { Box, Icon, Text } from '@nimbus-ds/components';

export function InfoDomainCardSkeleton() {
  return (
    <Box
      borderColor="primary-interactive"
      borderStyle="solid"
      borderWidth="1"
      borderRadius="2"
      padding="4"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box display="flex" flexDirection="column" gap="1" flex="1">
        <Text.Skeleton width="150px" fontSize="base" />
        <Text.Skeleton width="250px" fontSize="caption" />
      </Box>
      <Icon.Skeleton />
    </Box>
  );
}
